import { isEqual } from 'lodash'

export const validateSubnetMask = (value: string) => {
  //
  // empty value evaluates to true to allow empty field
  // to pass validation. Use 'required' validation
  // in addition to this one to validate for presence
  // of value.
  //
  if (isEqual(value, '')) {
    return true
  }
  const regex =
    /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\/[0-2]?\d|\/3[0-2])?$/
  return regex.test(value) || subnetMaskHint
}

export const subnetMaskHint = 'Valid IPv4 subnet (xxx.xxx.xxx.xxx/xx)'
